/**
 * Storage Priority Levels
 */
export enum StoragePriority {
  // eslint-disable-next-line no-unused-vars
  CRITICAL = 0, // Never deleted (e.g., auth tokens)
  // eslint-disable-next-line no-unused-vars
  IMPORTANT = 1, // Deleted only for CRITICAL (e.g., session data)
  // eslint-disable-next-line no-unused-vars
  NORMAL = 2, // Deleted for IMPORTANT and CRITICAL (e.g., cached departments)
  // eslint-disable-next-line no-unused-vars
  LOW = 3, // Deleted first (e.g., console logs, chat history)
}

export interface QuotaInfo {
  used: number;
  total: number;
  remaining: number;
  percentUsed: number;
}
